export default "__VITE_ASSET__AlyAyKiU__"